export default {"src":"/_next/static/media/angle-left.f393192f.svg","height":12,"width":7,"blurWidth":0,"blurHeight":0};